import { Cancel, Search } from "@mui/icons-material"
import { InputAdornment, TextField } from "@mui/material"
import type { SxProps, Theme } from "@mui/material"
import { QuickFilter, QuickFilterClear, QuickFilterControl, Toolbar } from "@mui/x-data-grid-premium"

export const SEARCH_WIDTH = "20rem"

const SEARCH_SX = { width: SEARCH_WIDTH, maxWidth: "100%" } satisfies SxProps<Theme>

/**
 * Always expanded, unlike the table artifact's collapsing trigger it replaces: sorting aside, search is
 * this list's only way to narrow itself, and a magnifier that has to be found first hid that.
 */
export function ToolbarWithSearch({ placeholder, ariaLabel }: { placeholder: string, ariaLabel: string }) {
  return (
    <Toolbar>
      <QuickFilter expanded>
        <QuickFilterControl
          render={({ ref, ...controlProps }, state) => (
            <TextField
              {...controlProps}
              inputRef={ref}
              size="small"
              placeholder={placeholder}
              sx={SEARCH_SX}
              slotProps={{
                ...controlProps.slotProps,
                // Spread first, then add: the control's own htmlInput carries role="searchbox", the label's
                // id, the collapsed tabIndex and its blur handler, and a later spread would drop all four.
                // The label goes here rather than bare on the TextField, which lands it on the root.
                htmlInput: { ...controlProps.slotProps?.htmlInput, "aria-label": ariaLabel },
                input: {
                  ...controlProps.slotProps?.input,
                  startAdornment: (
                    <InputAdornment position="start"><Search fontSize="small" /></InputAdornment>
                  ),
                  endAdornment: state.value === "" ? null : (
                    <InputAdornment position="end">
                      <QuickFilterClear edge="end" size="small" aria-label="Clear search">
                        <Cancel fontSize="small" />
                      </QuickFilterClear>
                    </InputAdornment>
                  ),
                },
              }}
            />
          )}
        />
      </QuickFilter>
    </Toolbar>
  )
}
